if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      showExternalImage(image) {
        const list = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
        if (!list || !image || !image.src) return;

        const mediaId = `${this.id}-bundle-component`;
        let slide = list.querySelector('[data-bundle-component-slide]');
        if (!slide) {
          const sampleContainer = list.querySelector('.product-media-container.media-type-image') || list.querySelector('.product-media-container');
          const containerClass = sampleContainer
            ? sampleContainer.className
            : 'product-media-container media-type-image media-fit-contain global-media-settings gradient constrain-height';

          slide = document.createElement('li');
          slide.id = `Slide-${this.id}-bundle-component`;
          slide.className = 'product__media-item grid__item slider__slide';
          slide.dataset.mediaId = mediaId;
          slide.dataset.bundleComponentSlide = 'true';
          slide.innerHTML = `<div class="${containerClass}"><div class="product__media media media--transparent"><img alt=""></div></div>`;
          list.prepend(slide);

          if (this.elements.thumbnails) {
            const thumbList = this.elements.thumbnails.querySelector('ul');
            if (thumbList) {
              const thumb = document.createElement('li');
              thumb.id = `Slide-Thumbnails-${this.id}-bundle-component`;
              thumb.className = 'thumbnail-list__item slider__slide';
              thumb.dataset.target = mediaId;
              thumb.dataset.mediaPosition = '1';
              thumb.dataset.bundleComponentThumb = 'true';
              thumb.innerHTML = '<button type="button" class="thumbnail global-media-settings global-media-settings--no-shadow" aria-label="Selected color"><img alt="" width="416" height="416"></button>';
              thumb.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaId, false));
              thumbList.prepend(thumb);
            }
          }
        }

        const ratio = image.width && image.height ? image.width / image.height : 1;
        const container = slide.querySelector('.product-media-container');
        if (container) {
          container.style.setProperty('--ratio', String(ratio));
          container.style.setProperty('--preview-ratio', String(ratio));
        }

        slide.querySelectorAll('img').forEach((img) => {
          img.src = image.src;
          img.alt = image.alt || '';
          img.removeAttribute('srcset');
          if (image.width) img.width = image.width;
          if (image.height) img.height = image.height;
        });

        if (this.elements.thumbnails) {
          const thumbImage = this.elements.thumbnails.querySelector('[data-bundle-component-thumb] img');
          if (thumbImage) {
            thumbImage.src = image.src;
            thumbImage.alt = image.alt || '';
            thumbImage.removeAttribute('srcset');
          }
        }

        this.setActiveMedia(mediaId, true);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
